import type { PopoverProps as PopoverNewProps } from './Popover';

export interface OldPopoverProps extends Omit<PopoverNewProps, 'closable' | 'shouldCloseOnOutsideClick' | 'open'> {
  /** @deprecated closable을 대신 사용해주세요. */
  closeButton?: boolean;
  /** @deprecated shouldCloseOnOutsideClick을 대신 사용해주세요. */
  canClickOutside?: boolean;
  /** @deprecated open을 대신 사용해주세요. */
  opened?: boolean;
}

export function convertOldPopoverProps(props: OldPopoverProps): PopoverNewProps {
  const { closeButton, canClickOutside, opened, ...restProps } = props;

  return {
    ...restProps,
    closable: closeButton,
    shouldCloseOnOutsideClick: canClickOutside,
    open: opened,
  };
}
